import { API } from '../utils/constants'

const services = {
  list: API + '/services',
  delete: API + '/services',
  register: API + '/services',
}

export async function getAllServices() {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(services.list, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function updateService(id: any, body: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(`${services.register}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function newService(body: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(services.register, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function deleteService(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.delete}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}
